export const newsList = [
  {
    id: "n1",
    title: "《暗涌》第二季官宣定档，原班人马回归开启新悬念",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20moody%20crime%20drama%20scene%20with%20rain%20streaked%20city%20street%20and%20deep%20red%20neon%20reflections%2C%20cinematic%20lighting%2C%20professional%20press%20photography%20aesthetic%2C%20high%20detail&width=800&height=500&seq=hp-news-01&orientation=landscape",
    date: "2026-10-12",
    summary:
      "备受好评的悬疑剧《暗涌》正式宣布第二季定档，编剧团队透露将延续第一季的冷峻质感，并引入全新案件线。",
    type: "电视剧",
    source: "黑皮辣妹编辑组",
    content:
      "备受好评的悬疑剧《暗涌》今日正式宣布第二季定档。制作方表示，第二季将继续由原班主创团队操刀，在保留第一季冷峻影像风格的基础上，引入一条跨越十年时间线的新案件。\n\n据透露，新一季将更深入地探讨主角沈焱的内心世界，同时加入几位关键新角色。片方公布的概念海报以雨夜城市为背景，延续了系列一贯的深红与暗调美学。\n\n业内分析认为，《暗涌》第一季凭借缜密的叙事和高完成度收获口碑，第二季有望进一步巩固其在国产悬疑剧中的位置。具体播出时间将于近期公布。",
    relatedWorkId: "w1",
  },
  {
    id: "n2",
    title: "科幻片《霓虹边缘》确认引进，记忆设定引发热议",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20futuristic%20neon%20city%20skyline%20at%20dusk%20with%20warm%20orange%20and%20deep%20red%20lights%2C%20sci%20fi%20press%20photography%20aesthetic%2C%20high%20detail%20cinematic&width=800&height=500&seq=hp-news-02&orientation=landscape",
    date: "2026-10-10",
    summary:
      "高概念科幻电影《霓虹边缘》确认引进，其关于“记忆租借”的设定在社交平台引发广泛讨论。",
    type: "电影",
    source: "影视观察",
    content:
      "由何家俊执导的科幻悬疑电影《霓虹边缘》确认引进。影片构建了一个记忆可以被租借与买卖的未来世界，主角作为记忆修复师被卷入一场关于身份的阴谋。\n\n该片的视觉风格被观众称为“兼具冷冽与华丽”，霓虹与深红的色调成为标志性符号。片方发布的预告片中，多个高概念场景引发二创热潮。\n\n有影评人指出，影片在科幻外壳之下讨论的其实是记忆与自我认同，是近年少见的兼顾作者表达与商业完成度的作品。",
    relatedWorkId: "w2",
  },
  {
    id: "n3",
    title: "《血色黄昏》口碑逆袭，动作片如何讲好亲情故事",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20lone%20figure%20silhouette%20against%20a%20burning%20amber%20sunset%20with%20dust%20and%20embers%2C%20epic%20cinematic%20press%20photography%20aesthetic%2C%20high%20detail&width=800&height=500&seq=hp-news-03&orientation=landscape",
    date: "2026-10-08",
    summary:
      "上映首周票房平稳的《血色黄昏》，凭借扎实的动作场面与克制的亲情内核，在第二周迎来口碑逆袭。",
    type: "电影",
    source: "黑皮辣妹编辑组",
    content:
      "《血色黄昏》上映第二周迎来口碑逆袭，多个平台的评分稳步上升。影片讲述一名退役特工为守护失散家人重返危险世界的故事。\n\n与多数强调爆炸场面的动作片不同，本片将大量笔墨放在人物关系的刻画上，导演马库斯·里德表示：“动作只是外壳，真正打动人的是人物为什么而战。”\n\n不少观众在评论区表示，片中几场近距离的动作戏与沉默的亲情段落形成强烈对比，让类型片拥有了情感厚度。",
    relatedWorkId: "w3",
  },
  {
    id: "n4",
    title: "文艺片《城南旧梦》重映，旧城记忆再引共鸣",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20nostalgic%20old%20town%20alley%20at%20golden%20hour%20with%20warm%20afternoon%20sunlight%2C%20soft%20shadows%2C%20tender%20cinematic%20press%20photography%20aesthetic&width=800&height=500&seq=hp-news-04&orientation=landscape",
    date: "2026-10-06",
    summary:
      "时隔四年，《城南旧梦》以修复版本重回大银幕，许多观众带着对旧城的记忆再次走进影院。",
    type: "电影",
    source: "文艺放映室",
    content:
      "文艺片《城南旧梦》以修复版本重映，导演许知远在映后交流中回忆了影片的创作缘起——那是一座真实存在的、正在拆迁的老城。\n\n影片以两个年轻人的最后一个夏天为主线，用舒缓的节奏记录了一段关于青春与故乡的告别。重映版本在画质与声音上做了精细修复。\n\n有观众表示，四年前看是青春，四年后再看却看懂了告别。这或许正是一部好电影随时间生长的力量。",
    relatedWorkId: "w4",
  },
  {
    id: "n5",
    title: "《深海回声》声音设计特辑发布，幽闭恐惧如何被制造",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20deep%20ocean%20underwater%20scene%20with%20cold%20dark%20water%20and%20a%20single%20faint%20red%20light%20beam%2C%20mysterious%20cinematic%20press%20photography&width=800&height=500&seq=hp-news-05&orientation=landscape",
    date: "2026-10-04",
    summary:
      "惊悚片《深海回声》发布声音设计特辑，揭秘影片如何通过声波与静默营造持续的心理压迫感。",
    type: "电影",
    source: "影视观察",
    content:
      "惊悚片《深海回声》发布幕后声音设计特辑。影片讲述一支深海考察队在海底发现不该存在的录音后，队员间信任逐渐瓦解的故事。\n\n声音团队透露，为了制造幽闭感，他们采集了大量真实水下环境音，并通过低频震动与突然的静默形成反差。导演朴承宇强调：“最恐怖的往往不是声音本身，而是声音消失之后。”\n\n特辑发布后，不少观众表示重新回看影片时会格外注意声音细节，这也让影片获得“需要戴耳机二刷”的评价。",
    relatedWorkId: "w5",
  },
  {
    id: "n6",
    title: "古装剧《烈火如歌》番外篇筹备中，主创透露新方向",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20an%20ancient%20Chinese%20palace%20courtyard%20at%20night%20with%20warm%20lantern%20glow%20and%20deep%20red%20drapes%2C%20elegant%20period%20drama%20press%20photography%20aesthetic&width=800&height=500&seq=hp-news-06&orientation=landscape",
    date: "2026-10-02",
    summary:
      "人气古装剧《烈火如歌》番外篇进入筹备阶段，主创表示将补充正片中未展开的支线故事。",
    type: "电视剧",
    source: "黑皮辣妹编辑组",
    content:
      "人气古装剧《烈火如歌》的番外篇正式进入筹备阶段。制片方表示，番外将聚焦正片中几条未充分展开的支线人物，以短剧形式呈现。\n\n该剧凭借华丽的服化道与紧凑的权谋节奏收获大量观众，男女主角之间由利用到交心的情感线尤为被讨论。\n\n主创在采访中透露，番外篇会尝试更轻盈的叙事节奏，同时保留系列一贯的美学风格。上线时间待定。",
    relatedWorkId: "w6",
  },
  {
    id: "n7",
    title: "《午夜列车》斩获影展最佳剧本，环形叙事获评审盛赞",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20dimly%20lit%20night%20train%20carriage%20with%20deep%20red%20interior%20lights%20and%20rain%20streaked%20windows%2C%20moody%20cinematic%20press%20photography&width=800&height=500&seq=hp-news-07&orientation=landscape",
    date: "2026-09-30",
    summary:
      "日本悬疑片《午夜列车》在某国际影展斩获最佳剧本奖，评审称赞其环形叙事结构精巧严密。",
    type: "电影",
    source: "影视观察",
    content:
      "日本悬疑电影《午夜列车》在某国际影展上斩获最佳剧本奖。影片设定在一列从未停靠的午夜列车上，七位乘客各怀秘密。\n\n评审团在评语中表示，影片的环形叙事结构“精巧到你必须重看一遍才能拼出全貌”，同时称赞其对记忆与救赎主题的处理克制而有力量。\n\n导演中村凉太在领奖时感谢了编剧团队，并透露剧本历经四年打磨、改稿超过二十次。",
    relatedWorkId: "w7",
  },
  {
    id: "n8",
    title: "《追光者》幕后训练花絮曝光，演员为角色增重减脂",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20sunrise%20running%20track%20with%20warm%20amber%20light%20rays%20and%20long%20shadows%2C%20hopeful%20cinematic%20press%20photography%20aesthetic&width=800&height=500&seq=hp-news-08&orientation=landscape",
    date: "2026-09-28",
    summary:
      "励志电影《追光者》曝光主演幕后训练花絮，为还原真实运动员状态，演员经历了数月体能训练。",
    type: "电影",
    source: "黑皮辣妹编辑组",
    content:
      "励志电影《追光者》曝光一组幕后训练花絮。影片讲述一名被伤病击倒的长跑运动员与年轻教练彼此成就的故事。\n\n为了贴近真实运动员的状态，主演在开拍前接受了数月系统训练，包括专项跑步、力量与饮食管理。教练组表示，片中大部分奔跑镜头由演员本人完成。\n\n导演程野表示，希望通过真实的训练日常，让观众感受到“普通人也能与命运赛跑”的力量。",
    relatedWorkId: "w8",
  },
  {
    id: "n9",
    title: "《罪案笔记》第三季开拍，新搭档组合引发期待",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20noir%20detective%20office%20at%20night%20with%20scattered%20files%20and%20warm%20red%20desk%20lamp%20glow%2C%20moody%20cinematic%20press%20photography&width=800&height=500&seq=hp-news-09&orientation=landscape",
    date: "2026-09-25",
    summary:
      "美剧《罪案笔记》第三季正式开拍，主创透露本季将引入一位新搭档，主角关系将迎来新变化。",
    type: "电视剧",
    source: "美剧速递",
    content:
      "美剧《罪案笔记》第三季正式开拍。该剧讲述一位记忆超群却社交障碍的犯罪分析师，与老探员搭档破案的故事。\n\n主创透露，第三季将引入一位新搭档，主角团队的化学反应会产生新的变化，同时主线将围绕一桩与主角过往相关的旧案展开。\n\n凭借单集一案、主线暗藏的叙事结构，该剧前两季积累了稳定口碑，新一季备受期待。",
    relatedWorkId: "w9",
  },
];